export default {
  startLoading: 'Start loading',
  finishLoading: 'Finish loading',
  loadEditDisabled: 'Only "planned" load can be edited.',
};
